export default __webpack_public_path__ + "static/media/9.65da7487.png";